import React, { useState } from 'react'
import PageSearchList from '../Utils/PageSearchList'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { useDispatch, useSelector } from 'react-redux'
import { getActiveToken, getToken } from '../../RTK/Slice/Auth/AuthSlice'
import { toast } from 'react-toastify'
import { getSearchPagesResults, searchPageAPI } from '../../RTK/Slice/Extract/ExtractPageSearchSlice'
import { STATUS } from '../../Constants'
import { useTranslation } from 'react-i18next'

const ExtractPageSearch = () => {

  // For Translate Page 
  const {t} = useTranslation() ; 

  // For Store Input Value
  const [search , setSearch] = useState('') ; 

  // For Get Token 
  const token = useSelector(getToken) ; 

  // For Dispatch Action
  const dispatch = useDispatch() ;

  // For Get Active Token 
  const activeToken = useSelector(getActiveToken) ; 
  

  // For Search Handler
  const searchPageHandler = (e)=>{
    e.preventDefault() ; 

    if(search !== ''){

      if(activeToken) {
        dispatch(searchPageAPI({
          token , 
          userToken : activeToken , 
          searchTerm : search
        }))
      }else{
        toast.info("Please Choose Token")
      }
    }
  }

  // For Access Data (data , status)
  const {data , status} = useSelector(getSearchPagesResults) ; 



  return (
    <section className='page-search-section' >
        <div className='search-items'>
          <form onSubmit={searchPageHandler}>
            <div className='search-bar'>
              <FontAwesomeIcon icon={faMagnifyingGlass} />
              <input value={search} onChange={(e)=>setSearch(e.target.value)} placeholder={t("search")} />
            </div>
            <button type='submit' >{t("search")}</button>
          </form>
          
        </div>
        {status === STATUS.SUCCESS ?data.length > 0 ? (<h3>The results : {data.length}</h3>):<h3 style={{margin:"10px 0px" , fontSize : "24px"}} >No Result Found</h3>  :""}
        <PageSearchList data={data} status={status} />
        
    </section>
  )
}

export default ExtractPageSearch
